import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Cta } from './Cta';
const stats: Array<{
  valor: string;
  etiqueta: string;
}> = [{
  valor: '6',
  etiqueta: 'Tomos completos'
}, {
  valor: '5',
  etiqueta: 'Bonos profesionales'
}, {
  valor: '300+',
  etiqueta: 'Recursos listos para usar'
}, {
  valor: '🌎',
  etiqueta: 'Países LATAM'
}];
export function Hero() {
  return <header className="w-full bg-canvas px-6 pb-16 pt-8 text-center" data-id="element-128" data-mp="129h2fs8fj8fj">
      <div className="mx-auto max-w-content" data-id="element-129" data-mp="128phdbcgkt3i">
        <p className="inline-flex rounded-full border border-brand-200 bg-brand-50 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-brand-700" style={{
        fontSize: "12px"
      }} data-id="element-130" data-mp="x9uqrn89208u">
          💅 Sistema digital premium para manicuras · LATAM 2026
        </p>

        <h1 className="mx-auto mt-3 max-w-4xl font-display text-4xl font-bold leading-[1.08] text-ink sm:text-5xl lg:text-[3.75rem]" style={{
        fontSize: "33px",
        fontWeight: "700"
      }} data-id="element-131" data-mp="neknkw647mth">
          Mega Pack Manicuria sin esclavitud <span aria-hidden="true" data-id="element-132" data-mp="3j8ivmv0mo8sl">💅</span>
        </h1>
        <p className="mx-auto mt-3 max-w-2xl font-display text-lg font-bold leading-snug text-brand-700 sm:text-2xl" style={{
        fontSize: "20px"
      }} data-id="element-133" data-mp="3j9247l4e1kty">
          Cobrá más y trabajá menos, desde hoy tene todo tu año de trabajo resuelto en minutos.
        </p>

        <figure className="mx-auto mt-3 max-w-5xl" data-id="element-134" data-mp="3e8wjyq0g70lw">
          <img src="https://cdn.magicpatterns.com/uploads/aC6mwtWhSoBtpNPbqC2dDJ/transparent_test_(1).png" alt="Combo completo del Mega Pack Manicuría Lista con sus 6 tomos y 5 bonos en PDF" className="mx-auto w-full max-w-3xl object-contain" width={1240} height={1240} data-id="element-135" data-mp="3e7l802wummjp" />
          <figcaption className="mt-4 font-display text-base font-bold text-brand-700 sm:text-lg" style={{
          fontSize: "18px"
        }} data-id="element-136" data-mp="2viev4wiqkp5t">
            Más rapidez, más ganancias y CERO improvisación.
          </figcaption>
        </figure>

        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-body sm:text-lg" data-id="element-137" data-mp="2ljgxn43c1lao">
          Implementá hoy mismo esta metodología para cobrar como una profesional y eliminar el
          agotamiento mental de tu negocio.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-sm text-muted" data-id="element-138" data-mp="n9i3jbjbrctl">
          6 Tomos + 5 Bonos (300+ recursos) · Acceso inmediato vía PDF · Venta disponible en toda LATAM.
        </p>

        <div className="mt-9 flex flex-col items-center" data-id="element-139" data-mp="db2cf8kas3k3">
          <Cta data-id="element-140" data-mp="1azuktd0gmlwu">Obtener el acceso AHORA</Cta>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-141" data-mp="1ayt710s27lbf">
            {['Cobrá lo que valés', 'Reducí tus tiempos', 'Cero estrés con clientas'].map(beneficio => <li key={beneficio} className="flex items-center gap-2 text-sm font-semibold text-body" data-id="element-142" data-mp="110wpnr8j3u4v">
                <CheckIcon className="h-4 w-4 text-brand-600" aria-hidden="true" data-id="element-143" data-mp="x37bsbv8g5ak" />
                {beneficio}
              </li>)}
          </ul>
          <p className="mt-4 text-sm text-muted" data-id="element-144" data-mp="3hr3q7rbx233p">
            Acceso inmediato · PDF descargable · Pago único · Sin suscripción
          </p>
          <p className="mt-2 text-sm font-medium text-brand-700" data-id="element-145" data-mp="1x783xkq1jlsj">
            💱 La plataforma convierte automáticamente a tu moneda local
          </p>
        </div>

        <dl className="mt-14 grid grid-cols-2 gap-8 rounded-3xl border border-edge bg-surface px-8 py-10 sm:grid-cols-4" data-id="element-146" data-mp="268y3xexznt1x">
          {stats.map(stat => <div key={stat.etiqueta} data-id="element-147" data-mp="2fzsqkkf5cunw">
              <dt className="sr-only" data-id="element-148" data-mp="2fyr8hvzpr7wo">{stat.etiqueta}</dt>
              <dd data-id="element-149" data-mp="2kyvmnfd5fqjq">
                <span className="block font-display text-3xl font-bold text-brand-700" data-id="element-150" data-mp="2kydryn64xkdx">{stat.valor}</span>
                <span className="mt-1 block text-sm text-muted" data-id="element-151" data-mp="2p08vzzfgabve">{stat.etiqueta}</span>
              </dd>
            </div>)}
        </dl>

        <p className="mt-5 text-sm font-medium text-muted" data-id="element-152" data-mp="2txhe600lmfwn">
          ⭐⭐⭐⭐⭐ 4.9/5 · Más de 2.500 manicuristas ya lo usan en toda LATAM
        </p>
      </div>
    </header>;
}